function Calculator2021(calculatorConfiguration, fundShares) {
  const self = this
  const averageSalary = calculatorConfiguration.yearlyAverageSalary
  const basePartCoefficient = calculatorConfiguration.basePartCoefficient
  const tenurePartCoefficient = calculatorConfiguration.tenurePartCoefficient
  const retirementLengthInMonths = calculatorConfiguration.retirementLength * 12
  const expectedEmploymentPeriodYears = 40

  this.calculate = function(pension, thirdPillarMonthlyContribution) {
    thirdPillarMonthlyContribution = thirdPillarMonthlyContribution || 0
    let secondPillar = pension.secondPillar
    let thirdPillar = pension.thirdPillar
    let customerHasSecondPillarFunds = secondPillar.assets.length > 0 && secondPillar.activeFunds.length > 0
    let currentSalary = pension.currentSalary || averageSalary

    const retirementYear = pension.retirementYear
    const retirementYearRounded = Math.floor(retirementYear)

    const workStartingYear = retirementYearRounded - expectedEmploymentPeriodYears
    const shares = self._shares(workStartingYear)

    const firstPillarData = calculateFirstPillar(customerHasSecondPillarFunds, shares, pension)
    const secondPillarData = calculateSecondPillar(secondPillar, pension, shares)
    const thirdPillarData = calculateThirdPillar(thirdPillar, pension, retirementYear, thirdPillarMonthlyContribution)

    const total = firstPillarData.monthlyAmount + secondPillarData.monthlyAmount + thirdPillarData.monthlyAmount
    const suspendTotal = firstPillarData.exit + secondPillarData.suspend + thirdPillarData.monthlyAmount
    const exitTotal = firstPillarData.exit + thirdPillarData.monthlyAmount

    return {
      firstPillar: firstPillarData,
      secondPillar: secondPillarData,
      thirdPillar: thirdPillarData,
      total: total,
      totalSuspend: suspendTotal,
      totalExit: exitTotal,
      totalSuspendLoss: suspendTotal - total,
      totalExitLoss: exitTotal - total,
      salaryGrowthAfterSuspend: (pension.currentSalary * 0.02) * 0.8,
      exitTaxes: secondPillar.balance * (calculatorConfiguration.incomeTax / 100),
      exitTotalAfterTaxes: secondPillar.balance * 0.8,
      exitSmallTaxes: secondPillar.balance * 0.1,
      exitTotalAfterSmallTaxes: secondPillar.balance * 0.9,
      suspendPercentOfCurrentSalary: 100.0 * suspendTotal / currentSalary,
      exitPercentOfCurrentSalary: 100.0 * exitTotal / currentSalary,
      percentOfCurrentSalary: 100.0 * total / currentSalary,
      yearsUntilRetirement: yearsUntilRetirement(retirementYear).toFixed(0)
    };
  }

  function calculateFirstPillar(customerHasSecondPillarFunds, shares, pension) {
    let monthlyAmount = customerHasSecondPillarFunds ?
      calculateFirstPillarWithP2P(shares, pension.currentSalary) :
      calculateFirstPillarWithoutP2P(shares, pension.currentSalary)

    return {
      monthlyAmount: monthlyAmount,
      exit: calculateFirstPillarExitFromP2P(shares, pension.currentSalary),
    }
  }

  function calculateSecondPillar(secondPillar, pension, shares) {
    const secondPillarEstimatedAmount = self._calculateSecondPillarEstimatedAmount(secondPillar.balance, pension.currentSalary, shares)

    return secondPillar.balance > 0 ? {
      monthlyAmount: secondPillarEstimatedAmount,
      assetsTotal: secondPillar.balance,
      growthAmount: secondPillar.balance - secondPillar.contribution - secondPillar.redemption,
      lastContribution: secondPillar.lastPayment ? secondPillar.lastPayment.total : 0,
      lastMonthContribution: secondPillar.lastMonthContribution,
      suspend: self._calculateSecondPillarExistingAmountPayments(secondPillar.balance),
      totalPaidByGovernment: self._calculateSecondPillarFutureState(pension.currentSalary, shares)
    } : {
      monthlyAmount: 0,
      assetsTotal: 0,
      growthAmount: 0,
      lastContribution: 0,
      lastMonthContribution: 0,
      suspend: 0,
      totalPaidByGovernment: 0
    }
  }

  function calculateThirdPillar(thirdPillar, pension, retirementYear, thirdPillarMonthlyContribution) {
    const thirdPillarEstimatedAmount = self._calculateThirdPillarMonthlyAmount(thirdPillar.totalAssets(), retirementYear, thirdPillarMonthlyContribution)

    if (thirdPillar.totalAssets() === 0 && thirdPillarMonthlyContribution > 0) {
      session.pension.thirdPillar.insuranceBalance = 1
    }

    return thirdPillar.totalAssets() > 0 ? {
      monthlyAmount: thirdPillarEstimatedAmount,
      assetsTotal: thirdPillar.totalAssets(),
      growthAmount: thirdPillar.balance - (thirdPillar.contribution - thirdPillar.redemption),
      lastContribution: thirdPillar.lastPayment.total,
      lastMonthContribution: thirdPillar.lastMonthContribution,
      taxReturn: taxReturn(retirementYear, pension.currentSalary, thirdPillarMonthlyContribution)
    } : {
      monthlyAmount: 0,
      assetsTotal: 0,
      growthAmount: 0,
      lastContribution: 0,
      lastMonthContribution: 0,
      taxReturn: 0
    }
  }

  function taxReturn(retirementYear, currentSalary, thirdPillarMonthlyContribution) {
    return Math.floor(
      (Math.min(
        calculatorConfiguration.maximumIncomeTaxBenefit,
        12 * Math.min(thirdPillarMonthlyContribution, currentSalary * calculatorConfiguration.maximumBenefitPercentageFromCurrentSalary / 100)
      ) * calculatorConfiguration.incomeTax / 100) * yearsUntilRetirement(retirementYear)
    )
  }

  this._shares = function(workStartingYear) {
    let shares = fundShares.find(yearConstants => yearConstants.year === workStartingYear)
    return shares === undefined ? fundShares[0] : shares
  }

  self._calculateSecondPillarEstimatedAmount = function(balance, salary, shares) {
    return self._calculateSecondPillarExistingAmountPayments(balance)
      + self._calculateSecondPillarGovernmentAmount(salary, shares)
      + self._calculateSecondPillarSelfAmount(salary, shares)
  }

  self._calculateSecondPillarSuspendAmount = function(balance, salary, shares) {
    return self._calculateSecondPillarExistingAmountPayments(balance)
      + self._calculateSecondPillarGovernmentAmount(salary, shares)
      + self._calculateSecondPillarSelfAmount(salary, shares)
  }

  self._calculateSecondPillarExistingAmountPayments = function(balance) {
    return balance / retirementLengthInMonths
  }

  self._calculateSecondPillarGovernmentAmount = function(salary, shares) {
    return self._calculateSecondPillarFutureState(salary, shares) / retirementLengthInMonths
  }

  self._calculateSecondPillarSelfAmount = function(salary, shares) {
    return self._calculateSecondPillarFutureOwn(salary, shares) / retirementLengthInMonths
  }

  self._calculateThirdPillarMonthlyAmount = function(assets, retirementYear, monthlyContribution) {
    let thirdPillarAssetsInRetirementAge = self._calculateThirdPillarAssetsInRetirementAge(assets, retirementYear, monthlyContribution)
    return thirdPillarAssetsInRetirementAge / retirementLengthInMonths
  }

  self._calculateThirdPillarAssetsInRetirementAge = function(assets, retirementYear, monthlyContribution) {
    const estimatedAssetsGrowth = yearsUntilRetirement(retirementYear) * 12 * monthlyContribution
    return assets + estimatedAssetsGrowth
  }

  function yearsUntilRetirement(retirementYear) {
    let currentYear = new Date().getFullYear()
    let currentMonth = 1 + new Date().getMonth()
    let today = currentYear + currentMonth / 12
    return retirementYear - today
  }

  self._calculateSecondPillarFutureState = function(salary, shares) {
    return shares.governmentP2P * salary * 12.0
  }

  self._calculateSecondPillarFutureOwn = function(salary, shares) {
    return shares.personalP2P * salary * 12.0
  }

  function calculateFirstPillarWithoutP2P(shares, currentSalary) {
    const firstRegimes = shares.first
    const secondRegimes = shares.second
    const thirdRegimes = shares.third

    return basePartCoefficient +
      tenurePartCoefficient * (firstRegimes + thirdRegimes / 2) +
      tenurePartCoefficient * currentSalary / averageSalary * (secondRegimes + thirdRegimes / 2)
  }

  function calculateFirstPillarWithP2P(shares, currentSalary) {
    const firstRegimes = shares.first
    const secondRegimes = shares.secondDisc
    const thirdRegimes = shares.third * 0.8

    return basePartCoefficient +
      tenurePartCoefficient * (firstRegimes + thirdRegimes / 2) +
      tenurePartCoefficient * currentSalary / averageSalary * (secondRegimes + thirdRegimes / 2)
  }

  function calculateFirstPillarExitFromP2P(shares, currentSalary) {
    const firstRegimes = shares.first
    const secondRegimes = shares.secondDisc
    const thirdRegimes = shares.third

    return basePartCoefficient +
      tenurePartCoefficient * (firstRegimes + thirdRegimes / 2) +
      tenurePartCoefficient * currentSalary / averageSalary * (secondRegimes + thirdRegimes / 2)
  }
}